import { ConfigurationLocalAccountingBillableClientsModalRulesItem } from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-rules/configuration-local-accounting-billable-clients-modal-rules.model'
import { ConfigurationLocalAccountingBillableClientsModalRulesVerifyRulesState, initialConfigurationLocalAccountingBillableClientsModalRulesVerifyRules } from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-verify-rules/configuration-local-accounting-billable-clients-modal-rules-verify-rules.model'
import { ConfigurationCustomerResponse, ConfigurationCustomerVerifyRulesRequest } from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/customer-services/configuration-local-accounting-billable-clients-customer-services.dto'
import { configurationLocalAccountingBillableCustomerService } from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/customer-services/configuration-local-accounting-billable-clients-customer-services.service'
import { configurationLocalAccountingBillableClientsHelpersGetCenters, configurationLocalAccountingBillableClientsHelpersGetInsurers, configurationLocalAccountingBillableClientsHelpersGetPetitioners } from '@/modules/configurationModule/detail/local-accounting/billable/clients/shared/configuration-local-accounting-billable-clients-helpers'
import { StrictNullable } from '@/shared/types/app.types'
import { BModal } from 'bootstrap-vue/src/components/modal'

import { Vue, Component, Ref, Prop } from 'vue-property-decorator'

@Component({
    components: {
    }
})
export default class ConfigurationLocalAccountingBillableClientsModalRulesVerifyRules extends Vue {
    @Ref() readonly clientsModalVerifyRules!: BModal
    @Prop() readonly laboratoryId!: number

    state: ConfigurationLocalAccountingBillableClientsModalRulesVerifyRulesState
    constructor() {
        super()
        this.state = initialConfigurationLocalAccountingBillableClientsModalRulesVerifyRules()
    }

    get validatedModel(): boolean {
        const validatedModel = !!this.state.centerSelected || !!this.state.insurerSelected || !!this.state.petitionerSelected
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return validatedModel && isDirty
    }

    show(): void {
        this.state = initialConfigurationLocalAccountingBillableClientsModalRulesVerifyRules()
        this.clientsModalVerifyRules.show()
    }

    onHide(): void {
        this.clientsModalVerifyRules.hide()
    }

    async onApply(): Promise<void> {
        const ruleToValidate: ConfigurationCustomerVerifyRulesRequest = {
            centerId: this.state.centerSelected?.id,
            insurerId: this.state.insurerSelected?.id,
            petitionerId: this.state.petitionerSelected?.id
        }
        const response: StrictNullable<ConfigurationCustomerResponse[]> = await this.$_toCallSecure(
            configurationLocalAccountingBillableCustomerService.verifyRules(this.laboratoryId!, ruleToValidate)
        )

        if (response) {
            if (response.length) {
                if (response.length > 1) {
                    const clients = response.map((client: ConfigurationCustomerResponse) => client.name)
                    this.$_showWarningModal(this.$tc('configuration.modal.client.clientsFound', 2, { clients: clients.join(', ') }))
                } else {
                    this.$_showInfoModal(this.$tc('configuration.modal.client.clientsFound', 1, { client: response[0].name }))
                }
            } else {
                this.$_showErrorModal(this.$tc('configuration.modal.client.clientsNotFound'))
            }
        }
    }

    async getCentersCombo(): Promise<ConfigurationLocalAccountingBillableClientsModalRulesItem[]> {
        return configurationLocalAccountingBillableClientsHelpersGetCenters()
    }

    async getInsurersCombo(): Promise<ConfigurationLocalAccountingBillableClientsModalRulesItem[]> {
        return configurationLocalAccountingBillableClientsHelpersGetInsurers()
    }

    async getPetitionersCombo(): Promise<ConfigurationLocalAccountingBillableClientsModalRulesItem[]> {
        return configurationLocalAccountingBillableClientsHelpersGetPetitioners()
    }
}
